<div class="g-slider-container">
  <div class="g-margin-bottom-30">
    <app-notification [type]="WARNING_TOASTER">
      {{ text.settings.env_config.pcap_player.play.slider.warning }}
    </app-notification>
  </div>

  <form [formGroup]="form">
    <div class="g-field-area">
        <app-ui-select
                formControlName="speed"
                [options]="speedDropdownData"
                [label]="text.settings.env_config.pcap_player.play.slider.play_speed_label"
                [isRequired]="true"
                [placeholder]="text.general.dropdown.select"
        >
        </app-ui-select>
    </div>
  </form>
</div>
